import { gql } from '@apollo/client';

export const GET_ACTIVITY_CANCELLATION_CLOSURE_REASONS = gql`
  query GetActivityCancellationAndClosureReasons {
    vm {
      activityCancellationReasons {
        activityCancellationReasonId
        label
      }
      activityClosureReasons {
        activityClosureReasonId
        label
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_SESSION_VISIBILITY = gql `
  query GetAdminConsoleOpsSessionVisibility {
    vm {
      configItem(key: "operations-allow-roster-session-visibility") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_CALENDAR_INVITES = gql`
  query GetAdminConsoleOpsCalendarInvites {
    vm {
      configItem(key: "operations-calendar-invites-enabled") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_ASSIGNED_ROSTERING_VIEW = gql`
  query GetAdminConsoleOpsAssignedRosteringView {
    vm {
      configItem(key: "operations-assigned-rostering-view") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_ROSTER_COMMENTS = gql`
  query GetAdminConsoleOpsRosterComments {
    vm {
      configItem(key: "allow-roster-comments") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_AVAILABILITY_RESTRICTION = gql`
  query GetAdminConsoleOpsAvailabilityRestriction {
    tm {
      tenant {
        config {
          availabilityRestrictionDays
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_SESSION_LIMITS = gql`
  query GetAdminConsoleOpsSessionLimits {
    tm {
      tenant {
        config {
          maxSessionsPerVolunteer
          minSessionsPerApplicant
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_DEFAULT_ROSTER_START_DATE = gql`
  query GetAdminConsoleOpsDefaultRosterStartDate {
    tm {
      tenant {
        config {
          defaultRosterStartDate
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_ALLOW_BACKUP_SESSIONS = gql`
  query GetAdminConsoleOpsAllowBackupSessions {
    vm {
      configItem(key: "allow-backup-sessions") {
        configItemId
        key
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_ADDRESS_HIDING = gql`
  query GetAdminConsoleOpsAddressHiding {
    tm {
      tenant {
        config {
          addressRevealBeforeDays
          addressHideAfterDays
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_ADDRESS_REMOVAL = gql`
  query GetAdminConsoleOpsAddressRemoval {
    vm {
      configItem(key: "address-remove-after-event") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_ADDRESS_ALLOW_DEFAULT = gql`
  query GetAdminConsoleOpsAddressAllowDefault {
    vm {
      configItem(key: "address-allow-default-display") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_ADDRESS_HIDE_EXEMPT_PM = gql`
  query GetAdminConsoleOpsAddressHideExemptPm {
    vm {
      configItem(key: "address-hide-exempt-pm") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_OPS_ADDRESS_HIDE_EXEMPT_AL = gql`
  query GetAdminConsoleOpsAddressHideExemptAl {
    vm {
      configItem(key: "address-hide-exempt-al") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;
